import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import propTypes from 'prop-types'
import DocumentTitle from 'react-document-title'
import { projectApi } from '@atheneum/api'

import Actions from './Actions'
import BatchActions from './BatchActions'
import EPLs from './EPLs/EPLs'
import Filters from './Filters'

class ExpertsPipeline extends Component {
  constructor(props) {
    super(props)
    this.props.eplStore.resetStore()
    projectApi.getUnresolvedEpls(this.props.projectStore.id).then(res => {
      if (res.hasUnresolvedEpls) {
        this.props.growlStore.showWarning(
          'Move EPL’s from Scheduled status as the scheduled date is in the past- click here to quick view',
          'Epls with wrong status',
          () => {
            this.props.eplStore.changeOption('eplStatuses', 8)
          }
        )
      }
    })
  }

  render() {
    const { project, capiDetails } = this.props.projectStore
    return (
      <DocumentTitle
        title={`${project.projectName} - experts pipeline | Atheneum Partners`}>
        <div className="ep-wrapper animate-intro">
          <Actions project={project} />
          <Filters project={project} />
          <BatchActions project={project} capiProject={capiDetails} projectStore={this.props.projectStore}/>
          {capiDetails && capiDetails.manual && (
            <div className="alert-box">
              <div className="alert-box-icon">!</div>
              <div>
                This is a manual McKinsey Project, auto-submission is not
                operational. Please use the excel to submit the experts. If the
                excel file does not exist please inform{' '}
                <a
                  href="https://atheneum-partners.atlassian.net/servicedesk/customer/portal/8"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#fff', fontWeight: '800' }}>
                  Digitalization Team.
                </a>
              </div>
            </div>
          )}
          <EPLs project={project} />
        </div>
      </DocumentTitle>
    )
  }
}

ExpertsPipeline.propTypes = {
  eplStore: propTypes.object,
  growlStore: propTypes.object,
  projectStore: propTypes.object
}

export default inject(
  'projectStore',
  'eplStore',
  'growlStore'
)(observer(ExpertsPipeline))
